// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"bef01ab3","286":"df489fa2","488":"4602fb0b"}[chunkId] + ".chunk.js";
};